import { MdOutlineCardMembership } from "react-icons/md";

import { numberToBRL } from "~/modules/sales/services";

import type { LicenseExtensionKPI } from "../types";

type Props = {
	data: LicenseExtensionKPI;
};

export const LicenseExtensionsCard: React.FC<Props> = ({ data }) => {
	return (
		<div className="bg-white rounded-xl shadow-md p-6 flex flex-col gap-4">
			<div className="flex items-center">
				<div className="p-3 bg-purple-100 rounded-lg">
					<MdOutlineCardMembership className="text-purple-600 text-xl" />
				</div>
				<h2 className="ml-3 text-lg font-semibold text-gray-700">
					Licenças Avulsas
				</h2>
			</div>

			<div className="grid grid-cols-2 gap-4">
				<div className="flex flex-col">
					<span className="text-sm text-gray-500">Vendas este mês</span>
					<span className="text-2xl font-bold text-gray-800">
						{data.totalPurchasesThisMonth}
					</span>
				</div>
				<div className="flex flex-col">
					<span className="text-sm text-gray-500">Receita este mês</span>
					<span className="text-2xl font-bold text-gray-800">
						{numberToBRL(data.totalRevenueThisMonth / 100)}
					</span>
				</div>
			</div>

			{data.topExtensions.length > 0 && (
				<div className="flex flex-col gap-1 mt-auto">
					<span className="text-xs font-semibold uppercase tracking-wide text-gray-400">
						Mais vendidos este mês
					</span>
					<table className="w-full text-sm">
						<tbody>
							{data.topExtensions.map((ext, i) => (
								<tr key={ext.name} className="border-t border-slate-100">
									<td className="py-1 text-gray-500">{i + 1}.</td>
									<td className="py-1 flex-1">{ext.name}</td>
									<td className="py-1 text-right text-gray-500">
										{ext.purchaseCount} venda
										{ext.purchaseCount !== 1 ? "s" : ""}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};
